import React from 'react';

type ComponentLoader<TProps> = () => Promise<{ default: React.ComponentType<TProps>; }>;

export function asLazyLoadable<TProps>(loader: ComponentLoader<TProps>): React.ComponentType<TProps> {
    return (props: TProps) => {
        const component: any = React.useMemo(() => React.lazy(loader), []);
        return React.createElement(component, props);
    };
}
